import React, { useLayoutEffect, useRef } from 'react';
import { Box } from '@mui/material';

type TabPanelEnterProps = {
  active: boolean;
  keepMounted?: boolean;
  children: React.ReactNode;
};

/** Replay dashCardIn whenever a UserDetail tab becomes active. */
const TabPanelEnter: React.FC<TabPanelEnterProps> = ({
  active,
  keepMounted = false,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !active) return;
    el.classList.remove('tab-panel-enter');
    void el.offsetWidth;
    el.classList.add('tab-panel-enter');
  }, [active]);

  if (!keepMounted && !active) return null;

  return (
    <Box
      ref={ref}
      className="tab-panel-enter"
      sx={{ display: active ? 'block' : 'none' }}
    >
      {children}
    </Box>
  );
};

export default TabPanelEnter;
